<template>
  <div class="sidebar">
    <el-menu
      class="el-menu-vertical-demo"
      background-color="#041728"
      text-color="#fff"
    >
      <!-- <router-link> -->
      <div class="left_logo">
        <img src="../../assets/img/Logo.png" alt="" />
      </div>
      <!-- </router-link> -->

      <router-link
        :to="{ path: '/' }"
        v-if="checkAuth(['1', '1-1', '1-2', '1-3', '1-4'])"
      >
        <el-menu-item index="1" :class="index_active == 1 ? 'link_active' : ''">
          <img
            v-if="index_active == 1"
            class="left_icon"
            src="../../assets/img/left_icon1_js.png"
            alt=""
          />
          <img
            v-else
            class="left_icon"
            src="../../assets/img/left_icon1.png"
            alt=""
          />
          <span slot="title">{{ $t("main.text12") }}</span>
        </el-menu-item>
      </router-link>

      <router-link
        :to="{ path: '/my_transaction' }"
        v-if="authjson.authjson(['2-1', '2-2', '2-3', '2-4', '2-5', '2-6'])"
      >
        <el-menu-item
          index="222"
          :class="index_active == 2 ? 'link_active' : ''"
        >
          <img
            v-if="index_active == 2"
            class="left_icon"
            src="../../assets/img/left_icon2_js.png"
            alt=""
          />
          <img
            v-else
            class="left_icon"
            src="../../assets/img/left_icon2.png"
            alt=""
          />
          <span slot="title">{{ $t("main.text746") }}</span>
        </el-menu-item>
      </router-link>

      <!-- 第三个 切换 -->
      <!-- <div class="sidebar_tit">{{$t('main.text25')}}</div> -->
      <router-link
        :to="{ path: '/blockchain_d' }"
        v-show="kyc_status == 4"
        v-if="checkAuth(['3', '3-1', '3-2', '3-3', '3-4', '3-5', '3-6', '3-7'])"
      >
        <el-menu-item index="3" :class="index_active == 3 ? 'link_active' : ''">
          <img
            v-if="index_active == 3"
            class="left_icon"
            src="../../assets/img/left_icon3_js.png"
            alt=""
          />
          <img
            v-else
            class="left_icon"
            src="../../assets/img/left_icon3.png"
            alt=""
          />
          <span slot="title">{{ $t("main.text14") }}</span>
        </el-menu-item>
      </router-link>

      <el-popover
        v-show="kyc_status != 4"
        v-if="checkAuth(['3', '3-1', '3-2', '3-3', '3-4', '3-5', '3-6', '3-7'])"
        placement="bottom-end"
        width="480"
        trigger="manual"
        popper-class="sidebar_pop_box"
        v-model="visible"
      >
        <router-link to="#" slot="reference">
          <!-- <router-link :to="{ path: '/blockchain_d' }" slot="reference"> -->
          <el-menu-item
            index="3"
            :class="index_active == 3 ? 'link_active' : ''"
            @click="visible = true"
          >
            <img
              v-if="index_active == 3"
              class="left_icon"
              src="../../assets/img/left_icon3_js.png"
              alt=""
            />
            <img
              v-else
              class="left_icon"
              src="../../assets/img/left_icon3.png"
              alt=""
            />
            <span slot="title">{{ $t("main.text14") }}</span>
          </el-menu-item>
        </router-link>
        <div class="pop_body">
          <div>
            <img
              class="pop_item1"
              src="../../assets/img/left_box_img.png"
              alt=""
            />
          </div>
          <div>
            <div class="pop_item2">{{ $t("main.text264") }}</div>
            <div class="pop_item3">{{ $t("main.text485") }}</div>
            <div class="pop_item3">{{ $t("main.text486") }}</div>
            <div class="pop_item3">{{ $t("main.text487") }}</div>
            <div>
              <el-button class="pop_item4" @click="visible = false">{{
                $t("main.text266")
              }}</el-button>
            </div>
          </div>
        </div>
      </el-popover>

      <!-- 第四个 切换 -->
      <router-link
        :to="{ path: '/blockchain_w' }"
        v-show="kyc_status == 4"
        v-if="
          checkAuth([
            '11',
            '11-1',
            '11-2',
            '11-3',
            '11-4',
            '11-5',
            '11-6',
            '11-7',
            '11-8',
            '11-9',
            '11-10',
          ])
        "
      >
        <el-menu-item index="4" :class="index_active == 4 ? 'link_active' : ''">
          <img
            v-if="index_active == 4"
            class="left_icon"
            src="../../assets/img/left_icon4_js.png"
            alt=""
          />
          <img
            v-else
            class="left_icon"
            src="../../assets/img/left_icon4.png"
            alt=""
          />
          <span slot="title">{{ $t("main.text15") }}</span>
        </el-menu-item>
      </router-link>

      <el-popover
        v-show="kyc_status != 4"
        v-if="
          checkAuth([
            '11',
            '11-1',
            '11-2',
            '11-3',
            '11-4',
            '11-5',
            '11-6',
            '11-7',
            '11-8',
            '11-9',
            '11-10',
          ])
        "
        placement="bottom-end"
        width="480"
        trigger="manual"
        popper-class="sidebar_pop_box"
        v-model="visible2"
      >
        <router-link to="#" slot="reference">
          <!-- <router-link :to="{ path: '/blockchain_w' }" slot="reference"> -->
          <el-menu-item
            index="4"
            :class="index_active == 4 ? 'link_active' : ''"
            @click="visible2 = true"
          >
            <img
              v-if="index_active == 4"
              class="left_icon"
              src="../../assets/img/left_icon4_js.png"
              alt=""
            />
            <img
              v-else
              class="left_icon"
              src="../../assets/img/left_icon4.png"
              alt=""
            />
            <span slot="title">{{ $t("main.text15") }}</span>
          </el-menu-item>
        </router-link>

        <div class="pop_body">
          <div>
            <img
              class="pop_item1"
              src="../../assets/img/left_box_img.png"
              alt=""
            />
          </div>
          <div>
            <div class="pop_item2">{{ $t("main.text264") }}</div>
            <div class="pop_item3">{{ $t("main.text485") }}</div>
            <div class="pop_item3">{{ $t("main.text486") }}</div>
            <div class="pop_item3">{{ $t("main.text487") }}</div>
            <div>
              <el-button class="pop_item4" @click="visible2 = false">{{
                $t("main.text266")
              }}</el-button>
            </div>
          </div>
        </div>
      </el-popover>

      <!-- <div class="sidebar_tit">{{$t('main.text26')}}</div>
      <router-link :to="{ path: '/fiat_deposit' }">
        <el-menu-item index="5" :class="index_active==5?'link_active':'' ">
          <img v-if="index_active==5" class="left_icon" src="../../assets/img/left_icon5_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon5.png" alt="">
          <span slot="title">{{$t('main.text16')}}</span>
        </el-menu-item>
      </router-link>

      <router-link :to="{ path: '/fiat_withdrawal' }">
        <el-menu-item index="6" :class="index_active==6?'link_active':'' ">
          <img v-if="index_active==6" class="left_icon" src="../../assets/img/left_icon6_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon6.png" alt="">
          <span slot="title">{{$t('main.text17')}}</span>
        </el-menu-item>
      </router-link> -->

      <div
        class="sidebar_tit"
        v-if="
          checkAuth([
            '4',
            '4-1',
            '4-2',
            '4-3',
            '4-4',
            '4-5',
            '4-6',
            '4-7',
            '4-8',
          ])
        "
      >
        {{ $t("main.text27") }}
      </div>
      <!-- 第五个 切换 -->
      <router-link
        :to="{ path: '/cards_view' }"
        v-show="kyc_status == 4"
        v-if="
          checkAuth([
            '4',
            '4-1',
            '4-2',
            '4-3',
            '4-4',
            '4-5',
            '4-6',
            '4-7',
            '4-8',
          ])
        "
      >
        <el-menu-item
          index="12"
          :class="index_active == 12 ? 'link_active' : ''"
        >
          <img
            v-if="index_active == 12"
            class="left_icon"
            src="../../assets/img/left_icon12_js.png"
            alt=""
          />
          <img
            v-else
            class="left_icon"
            src="../../assets/img/left_icon12.png"
            alt=""
          />
          <span slot="title">{{ $t("main.text512") }}</span>
        </el-menu-item>
      </router-link>

      <el-popover
        v-show="kyc_status != 4"
        v-if="
          checkAuth([
            '4',
            '4-1',
            '4-2',
            '4-3',
            '4-4',
            '4-5',
            '4-6',
            '4-7',
            '4-8',
          ])
        "
        placement="bottom-end"
        width="480"
        trigger="manual"
        popper-class="sidebar_pop_box"
        v-model="visible3"
      >
        <router-link to="#" slot="reference">
          <!-- <router-link :to="{ path: '/blockchain_w' }" slot="reference"> -->
          <el-menu-item
            index="12"
            :class="index_active == 12 ? 'link_active' : ''"
            @click="visible3 = true"
          >
            <img
              v-if="index_active == 4"
              class="left_icon"
              src="../../assets/img/left_icon12_js.png"
              alt=""
            />
            <img
              v-else
              class="left_icon"
              src="../../assets/img/left_icon12.png"
              alt=""
            />
            <span slot="title">{{ $t("main.text512") }}</span>
          </el-menu-item>
        </router-link>

        <div class="pop_body">
          <div>
            <img
              class="pop_item1"
              src="../../assets/img/left_box_img.png"
              alt=""
            />
          </div>
          <div>
            <div class="pop_item2">{{ $t("main.text264") }}</div>
            <div class="pop_item3">{{ $t("main.text485") }}</div>
            <div class="pop_item3">{{ $t("main.text486") }}</div>
            <div class="pop_item3">{{ $t("main.text487") }}</div>
            <div>
              <el-button class="pop_item4" @click="visible3 = false">{{
                $t("main.text266")
              }}</el-button>
            </div>
          </div>
        </div>
      </el-popover>

      <!-- <router-link :to="{ path: '/otc' }"
      v-if="checkAuth(['5'])">
        <el-menu-item index="7" :class="index_active==7?'link_active':'' ">
          <img v-if="index_active==7" class="left_icon" src="../../assets/img/left_icon7_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon7.png" alt="">
          <span slot="title">{{$t('main.text18')}}</span>
        </el-menu-item>
      </router-link> -->

      <!-- <router-link :to="{ path: '/fx' }">
        <el-menu-item index="8" :class="index_active==8?'link_active':'' ">
          <img v-if="index_active==8" class="left_icon" src="../../assets/img/left_icon8_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon8.png" alt="">
          <span slot="title">{{$t('main.text19')}}</span>
        </el-menu-item>
      </router-link> -->

      <!-- <router-link :to="{ path: '/private_b_p' }"
      v-if="checkAuth(['6'])">
        <el-menu-item index="9" :class="index_active==9?'link_active':'' ">
          <img v-if="index_active==9" class="left_icon" src="../../assets/img/left_icon9_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon9.png" alt="">
          <span slot="title">{{$t('main.text267')}}</span>
        </el-menu-item>
      </router-link> -->

      <!-- <router-link :to="{ path: '/structured_p' }"
      v-if="checkAuth(['7'])">
        <el-menu-item index="10" :class="index_active==10?'link_active':'' ">
          <img v-if="index_active==10" class="left_icon" src="../../assets/img/left_icon10_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon10.png" alt="">
          <span slot="title">{{$t('main.text268')}}</span>
        </el-menu-item>
      </router-link> -->

      <!-- <router-link :to="{ path: '/investment_b' }"
      v-if="checkAuth(['8'])">
        <el-menu-item index="11" :class="index_active==11?'link_active':'' ">
          <img v-if="index_active==11" class="left_icon" src="../../assets/img/left_icon11_js.png" alt="">
          <img v-else class="left_icon" src="../../assets/img/left_icon11.png" alt="">
          <span slot="title">{{$t('main.text269')}}</span>
        </el-menu-item>
      </router-link> -->

      <!-- v-if="checkAuth(['9','9-1','9-2','9-3','9-4','9-5','9-6','9-7','9-8','9-9','9-10','9-11','9-12','9-13','9-14','9-15','9-16','9-17','9-18','9-19'])" -->
      <el-submenu index="12" class="submenu_select">
        <template slot="title">
          <img
            v-if="
              index_active == 13 || index_active == 14 || index_active == 16
            "
            class="left_icon"
            src="../../assets/img/left_icon13_js.png"
            alt=""
          />
          <img
            v-else
            class="left_icon"
            src="../../assets/img/left_icon13.png"
            alt=""
          />
          <span
            :class="
              index_active == 13 || index_active == 14 || index_active == 16
                ? 'link_active2'
                : ''
            "
            >{{ $t("bank_card.Card_management") }}</span
          >
        </template>
        <template v-if="checkAuth(['9', '9-1', '9-11', '9-2', '9-3', '9-4'])">
          <router-link
            :to="{ path: '/contract_management' }"
            v-if="haveContract"
          >
            <el-menu-item
              index="12-1"
              :class="index_active == 13 ? 'link_active' : ''"
              >{{ $t("bank_card.contract_management") }}</el-menu-item
            >
          </router-link>
        </template>
        <router-link
          :to="{ path: '/card_management' }"
          v-if="
            checkAuth([
              '9-5',
              '9-6',
              '9-10',
              '9-19',
              '9-12',
              '9-13',
              '9-14',
              '9-16',
              '9-17',
              '9-18',
            ])
          "
        >
          <el-menu-item
            index="12-2"
            :class="index_active == 14 ? 'link_active' : ''"
            >{{ $t("bank_card.Cards_List") }}</el-menu-item
          >
        </router-link>
        <router-link
          :to="{ path: '/kycManage' }"
          v-if="checkAuth(['12', '12-1', '12-2', '12-3', '12-4', '12-5'])"
        >
          <el-menu-item
            index="16"
            :class="index_active == 16 ? 'link_active' : ''"
            >{{ $t("bank_card.KYC_Management") }}</el-menu-item
          >
        </router-link>
        <router-link
          :to="{ path: '/renew' }"
          v-if="
          checkAuth(['13', '13-1', '13-2', '13-3', '13-4', '13-5','13-6'])&&
          ['RapidzMaximus', 'BETH'].includes(project_name)&&
          [0,1,3].includes(company_type)
          ">
          <el-menu-item
            index="17"
            :class="index_active == 17 ? 'link_active' : ''"
            >{{ $t("beth_text.renew") }}</el-menu-item
          >
        </router-link>
      </el-submenu>

      <div class="sidebar_tit" v-if="checkAuth(['10'])">
        {{ $t("bank_card.CONTROLS") }}
      </div>
      <router-link
        :to="{ path: '/concealed_accounts' }"
        v-if="checkAuth(['10']) && userType == 1"
      >
        <el-menu-item
          index="15"
          :class="index_active == 15 ? 'link_active' : ''"
        >
          <img
            v-if="index_active == 15"
            class="left_icon"
            src="../../assets/img/left_icon14_js.png"
            alt=""
          />
          <img
            v-else
            class="left_icon"
            src="../../assets/img/left_icon14.png"
            alt=""
          />
          <span slot="title">{{ $t("bank_card.Ass_management") }}</span>
        </el-menu-item>
      </router-link>

    </el-menu>

    <!-- 法定货币存取服务暂时中断通知 -->
    <el-dialog
      :title="
        v_lan == 'ch'
          ? '新技费用调整公告'
          : v_lan == 'jp'
          ? 'FEB銀行 手数料改定のお知らせ'
          : v_lan == 'en'
          ? 'FEB Fee Revision Announcement'
          : ''
      "
      :visible.sync="fa_dlg"
      custom-class="auto_log_out_dlg_bgc2"
      append-to-body
      width="480px"
    >
      <div v-if="v_lan == 'ch'">
        <div class="log_out3">
          <div>亲爱的客户，</div>
          <div>自 2026 年 1 月 1 日 起，法币提现 的转账手续费将调整为：</div>
          <div>100 美元 + 0.75%</div>
          <div>所有兑换将依照 FEB 当时的汇率标准 执行。</div>
          <div>感谢您的理解与长期支持。</div>
          <div>如有任何疑问，欢迎随时联系客户服务团队。</div>
        </div>
      </div>

      <div v-else-if="v_lan == 'jp'">
        <div class="log_out3">
          <div>お客様各位</div>
          <div>2026年1月1日 より、法定通貨の出金 に関する振替手数料を以下の通り改定いたします。</div>
          <div>100米ドル + 0.75%</div>
          <div>また、すべての通貨換算は FEBの最新の為替レート に基づいて行われます。</div>
          <div>ご理解とご協力に心より感謝申し上げます。</div>
          <div>ご不明な点がございましたら、カスタマーサービスまでお問い合わせください。</div>
        </div>
      </div>

      <div v-else>
        <div class="log_out3">
          <div>Dear Valued Customer,</div>
          <div>Starting January 1, 2026, the transfer fee for fiat withdrawals will be updated to:</div>
          <div>USD 100 + 0.75%</div>
          <div>All conversions will be subject to FEB’s prevailing exchange rates.</div>
          <div>We appreciate your understanding and continued support.</div>
          <div>If you have any questions, feel free to contact our Customer Service Team.</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfo } from "@/api/api";

export default {
  data() {
    return {
      index_active: 1,
      visible: false,
      visible2: false,
      visible3: false,
      kyc_status: 0,
      userType: sessionStorage.getItem("userType"),
      haveContract: sessionStorage.getItem("haveContract"),

      fa_dlg: false,
      project_name:"",
      company_type:"",
    };
  },
  created() {
    if (sessionStorage.getItem("token") && sessionStorage.getItem("userid")) {
      if (!sessionStorage.getItem("fa_dlg")) {
        this.fa_dlg = true;
        sessionStorage.setItem("fa_dlg", false);
      }
    }
    this.get_user_info();
  },
  methods: {
    set_active() {
      if (this.$route.path == "/") {
        this.index_active = 1;
      } else if (
        this.$route.path == "/my_transaction" ||
        this.$route.path == "/my_transaction_info"
      ) {
        this.index_active = 2;
      } else if (this.$route.path.indexOf("blockchain_d") != -1) {
        this.index_active = 3;
      } else if (this.$route.path.indexOf("blockchain_w") != -1) {
        this.index_active = 4;
      } else if (this.$route.path.indexOf("fiat_deposit") != -1) {
        this.index_active = 5;
      } else if (this.$route.path.indexOf("fiat_withdrawal") != -1) {
        this.index_active = 6;
      } else if (this.$route.path.indexOf("otc") != -1) {
        this.index_active = 7;
      } else if (this.$route.path.indexOf("fx") != -1) {
        this.index_active = 8;
      } else if (this.$route.path.indexOf("private_b_p") != -1) {
        this.index_active = 9;
      } else if (this.$route.path.indexOf("structured_p") != -1) {
        this.index_active = 10;
      } else if (this.$route.path.indexOf("investment_b") != -1) {
        this.index_active = 11;
      } else if (this.$route.path.indexOf("cards_view") != -1) {
        this.index_active = 12;
      } else if (this.$route.path.indexOf("contract_management") != -1) {
        this.index_active = 13;
      } else if (this.$route.path.indexOf("card_management") != -1) {
        this.index_active = 14;
      } else if (this.$route.path.indexOf("concealed_accounts") != -1) {
        this.index_active = 15;
      } else if (this.$route.path.indexOf("kycManage") != -1) {
        this.index_active = 16;
      } else if (this.$route.path.indexOf("renew") != -1) {
        this.index_active = 17;
      }
    },
    checkAuth(v) {
      let arr_json = "";
      if (
        (sessionStorage.getItem("userType") &&
          sessionStorage.getItem("userType") == 1) ||
        (sessionStorage.getItem("form_admin") &&
          sessionStorage.getItem("form_admin") == "admin")
      ) {
        // if(
        // sessionStorage.getItem("userType")&&sessionStorage.getItem("userType")==1
        // ){
        arr_json = JSON.parse(sessionStorage.getItem("authjson"));
      } else {
        arr_json = JSON.parse(JSON.parse(sessionStorage.getItem("authjson")));
      }
      v = JSON.parse(JSON.stringify(v));
      const arr2 = [...v];
      let res = "";
      for (let i = 0; i < arr2.length; i++) {
        if (arr_json.includes(arr2[i])) {
          res = true;
          break;
        }
      }
      return res;
    },
    get_user_info() {
      getUserInfo().then((res) => {
        if (res.data.code == 200) {
          // haveContract 是否有合同
          const haveContract = res.data.data.haveContract;
          haveContract && sessionStorage.setItem("haveContract", haveContract);
          this.haveContract = haveContract;

          this.project_name = res.data.data.project_name;
          this.company_type  = res.data.data.company_type;
        }
      });
    },
  },
  mounted() {
    this.set_active();
    // kyc_status: KYC状态 0没有 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败
    // 4审核通过 路由才能跳转
    if (sessionStorage.getItem("kyc_status")) {
      this.kyc_status = sessionStorage.getItem("kyc_status");
    }
    this.haveContract = sessionStorage.getItem("haveContract");
  },
  watch: {
    $route() {
      this.set_active();
      this.get_user_info();
    },
  },
};
</script>

<style scoped>
.sidebar {
  width: 320px;
}
.left_logo {
  width: 94%;
  margin-bottom: 35px;
}
.left_logo img {
  /* max-width: 200px; */
  max-width: 150px;
  margin: 20px auto 10px;
  display: inherit;
}
.el-menu {
  height: 100vh;
  overflow: hidden;
  border-right: none;
  min-height: 100vh;
  overflow-y: auto;
}
.sidebar_tit {
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.06em;
  color: #ffffff;
  opacity: 0.4;
  padding-left: 25px;
  box-sizing: border-box;
  width: 86%;
  margin: auto;
  margin-top: 35px;
  margin-bottom: 5px;
}
.sidebar .link_active {
  color: rgb(222, 185, 129) !important;
  background: #041e35 !important;
  font-weight: bold;
  border-radius: 8px;
}
.sidebar .link_active2 {
  color: rgb(222, 185, 129) !important;
}
.el-menu-item.is-active {
  color: #fff;
}
.el-menu-item {
  width: 82%;
  margin: auto;
  height: 45px;
  line-height: 45px;
}
.left_icon {
  width: 20px;
  margin-right: 10px;
  vertical-align: middle;
}
/* .submenu_select >>> .el-submenu__title:hover,
.submenu_select >>> .el-menu:hover,
.submenu_select >>> .el-menu-item:hover{
  background: none !important;
} */
.submenu_select {
  width: 82%;
  margin: auto;
  /* height: 45px; */
  line-height: 45px;
}
.submenu_select .el-menu-item {
  width: 90%;
  margin: auto;
  height: 45px;
  line-height: 45px;
}
</style>

<style>
.sidebar_pop_box {
  /* background: #041E35 !important;#314B69 */
  background: rgb(30 75 114) !important;
  border-radius: 16px !important;
  border: none !important;
  color: #fff;
  box-sizing: border-box;
  padding: 28px;
  word-break: break-word;
  word-wrap: break-word;
  text-align: left;
  margin-left: 42px;
}
/* .sidebar_pop_box::after{ */
.sidebar_pop_box::before {
  content: "";
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: -1;
}
.sidebar_pop_box .popper__arrow {
  display: none;
}
.sidebar_pop_box .pop_body {
  display: flex;
}
.sidebar_pop_box .pop_item1 {
  width: 60px;
  margin-right: 20px;
}
.sidebar_pop_box .pop_item2 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  margin-bottom: 4px;
}
.sidebar_pop_box .pop_item3 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  color: rgba(255, 255, 255, 0.8);
  /* margin-bottom: 20px; */
}
.sidebar_pop_box .pop_item3:nth-child(4) {
  margin-bottom: 20px;
}

.sidebar_pop_box .pop_item4,
.sidebar_pop_box .pop_item4:hover,
.sidebar_pop_box .pop_item4:focus,
.sidebar_pop_box .pop_item4:active {
  min-width: 120px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #04182a;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  border: none;
}
</style>

<style>
/* 退出 弹框 */
.auto_log_out_dlg_bgc2 {
  background: #041e35 !important;
  color: #fff;
  border-radius: 16px !important;
}
/* .auto_log_out_dlg_bgc .el-dialog__header {
  padding: 0 !important;
} */
.auto_log_out_dlg_bgc2 .log_out2 {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
  margin-bottom: 16px;
  text-align: center;
  word-break: break-word;
  word-wrap: break-word;
  text-align: left;
}
.auto_log_out_dlg_bgc2 .log_out3 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  color: #ffffff;
  opacity: 0.8;
  margin-top: 8px;
  text-align: center;
  word-break: break-word;
  word-wrap: break-word;
  text-align: left;
}
.auto_log_out_dlg_bgc2 .log_out3 div {
  margin: 15px;
}
.auto_log_out_dlg_bgc2 .el-dialog__headerbtn {
  right: initial !important;
}
.auto_log_out_dlg_bgc2 .el-dialog__title {
  color: #fff;
}
.auto_log_out_dlg_bgc2 .el-dialog__header {
  display: flex;
}
/* --over-- */
</style>

